import { GetReportsOptions } from '@card/commonlib';
import { Report, Paginated, ActionsType } from '@card/types';
import { createAction } from '../../actions/actionCreator';

export enum ReportsActionType {
  FetchReportsStarted = 'reports/fetch_started',
  FetchReportsSuccess = 'reports/fetch_success',
  FetchReportsError = 'reports/fetch_error'
}

export const ReportsActions = {
  fetchStarted: (options: GetReportsOptions) =>
    createAction(ReportsActionType.FetchReportsStarted, options),
  fetchSuccess: (data: Paginated<Report>) =>
    createAction(ReportsActionType.FetchReportsSuccess, data),
  fetchError: (error: Error) => createAction(ReportsActionType.FetchReportsError, error)
};

export type ReportsAction = ActionsType<typeof ReportsActions>;
